// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-divider{padding:5px 0;margin:25px 35px 0 35px;border-top-width:2px;border-top-style:solid;border-top-color:#c3c2c7}#overview-service-tab .v-toolbar{background:#fafafa!important;border-bottom:2px solid #f4f2f9!important}#overview-service-tab .custom-app-bar{background-color:transparent!important;border-bottom:none!important}", ""]);
// Exports
module.exports = exports;
